// © Microsoft Corporation. All rights reserved.
import { AppType, environment } from "../wwCommon";
import { PlatformType } from "@msnews/config-data-types";
import { stringHasData } from "./Utility";
/**
 * Sets target scope for current request.
 */
export function getTargetScope() {
    var _a;
    const { apptype, audienceMode, browser, deviceFormFactor, isGitConfigs, ocid, os, pcsPagetype: pageType, currentFlights, pcsLocale, pcsDomain } = environment;
    const currentRequestTargetScope = {
        audienceMode,
        browser,
        deviceFormFactor,
        domain: pcsDomain,
        locale: pcsLocale ? pcsLocale : environment.getLocaleObject(),
        ocid,
        os,
        platform: PlatformType.Web,
        pageType
    };
    const flights = environment.currentFlights;
    if (stringHasData(flights)) {
        currentRequestTargetScope.pageExperiments = flights.split(",");
    }
    // Hacky temporary flight addition for hub windows git scenario
    if (apptype === AppType.Hub
        && ((_a = environment.getQueryParameter("ocid")) === null || _a === void 0 ? void 0 : _a.toLowerCase().substr(0, 3)) === "win"
        && isGitConfigs) {
        const currentPageExperiments = currentRequestTargetScope.pageExperiments || [];
        currentRequestTargetScope.pageExperiments = currentPageExperiments.concat("prg-iswin-hub");
    }
    return currentRequestTargetScope;
}
//# sourceMappingURL=Variables.js.map